module.exports = __webpack_public_path__ + "static/relayforjustice-8bffd7d102a593c437c4c4da78e659ed.svg";